import React from 'react'

const DiscountDeals = () => {
  return (
    <div>DiscountDeals</div>
  )
}

export default DiscountDeals